import React from "react";
import MarketCard from "./MarketCard";
const obj = require("../../profileimg.json");

const AllProfileImage = () => {
  return (
    <>
      {obj.map((value, i) => (
        <MarketCard key={i} value={value} variant="cover" category="profile" />
      ))}
    </>
  );
};

export default AllProfileImage;
